const stylesDesk = {
  containPageChat: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '80%',
    width: '100%',
    maxWidth: '1300px',
    padding: '10px',
  },
  containChats: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    width: '40%',
    padding: '10px',
    margin: '0px 10px 0px 0px',
    backgroundColor: 'white',
    borderRadius: '10px',
    border: '2px solid #FF7043',
  },
  containHeader: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    padding: '5px',
  },
  iconFixed: {
    position: 'absolute',
    top: '7px',
    left: '10px',
    color: '#FF7043',
    cursor: 'pointer',
    ':hover': {
      scale: '1.1',
    },
  },
  titleHeader: {
    textAlign: 'center',
    width: '100%',
  },
  containBtts: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
    margin: '5px 5px 0px 5px',
  },
  btnActive: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#ff7043',
    backgroundColor: '#d6d6d6',
    borderBottom: '2px solid #ff7043',
    borderRadius: '0px',
    padding: '10px 5px',
    '&:hover': {
      backgroundColor: '#d6d6d6',
    },
  },
  btnInactive: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: 'gray',
    backgroundColor: 'white',
    borderBottom: '2px solid gray',
    borderRadius: '0px',
    padding: '10px 5px',
    '&:hover': {
      backgroundColor: '#f2f2f2',
    },
  },
  containList: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flex: 1,
    width: '100%',
    padding: '0px',

    border: '2px solid #d9d9d9',
    borderTop: 'none',
    borderRadius: '0px 0px 7px 7px',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#FF7043',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1',
    },
  },
  containLine: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: '0px',
    width: '100%',
    borderBottom: '2px solid #d9d9d9',
  },
  containChat: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    width: '65%',
    padding: '0px',
    backgroundColor: 'white',
    borderRadius: '10px',
    border: '2px solid #FF7043',
  },
  containListMensagens: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',

    alignItems: 'center',
    height: '100%',

    width: '100%',
    padding: '8px',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#FF7043',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1',
    },
  },
  containInputMensagens: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
    padding: '0px 5px 10px 5px',
    marginBotton: '10px',
  },
  inputMsg: {
    height: '100%',
    width: '100%',
    margin: '0px 5px',
    backgroundColor: '#d9d9d9',
    border: 'none',
    borderRadius: '7px',
  },
  btnSendMsg: {
    height: '100%',
    width: 'auto',
    backgroundColor: '#FF7043',
    padding: '0px 5px 0px 0px',
    borderRadius: '7px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: 'none',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#ff7043',
    },
  },
  iconSend: {
    height: '25px',
    width: '25px',
    color: '#FF7043',
  },
}

const stMob = {
  containPageChatMob: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  containHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
    padding: '7px',
  },
  iconBack: {
    cursor: 'pointer',
    color: '#FF7043',
  },
  titlePage: {
    fontSize: '28px',
    fontWeight: 'bold',
  },
  subTitlePg: {
    fontSize: '15px',
    color: 'gray',
  },
  containListChats: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    padding: '5px',
    marginTop: '-8px',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#FF7043',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1',
    },
  },
  borderBottom: {
    borderBottom: '1px solid #d9d9d9',
    boxShadow: '0px 0px 5px 0px #d9d9d9',
  },
  buttonPedido: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 'auto',
    width: 'calc(100% - 50px)',
    padding: '7px 15px',
    margin: '10px',
    backgroundColor: '#00cca3',
    color: 'white',
    fontSize: '16px',
    fontWeight: 'bold',
    borderRadius: '7px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#ff7043',
    },
  },
  containList: {
    display: 'flex',
    height: 'auto',
    width: '100%',
    borderBottom: '1px solid #d9d9d9',
  },
}

export { stylesDesk, stMob }
